/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_ToInputs */

const cs_properties_bulk_transfer_to = /** @type {(inputs: Properties_Bulk_Transfer_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový makléř`)
};

const en_properties_bulk_transfer_to = /** @type {(inputs: Properties_Bulk_Transfer_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New agent`)
};

/**
* | output |
* | --- |
* | "New agent" |
*
* @param {Properties_Bulk_Transfer_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_to = /** @type {((inputs?: Properties_Bulk_Transfer_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_to(inputs)
	return cs_properties_bulk_transfer_to(inputs)
});